import { render } from "./RecieptsCount.vue?vue&type=template&id=4dedde06&scoped=true"
const script = {}

import "./RecieptsCount.vue?vue&type=style&index=0&id=4dedde06&scoped=true&lang=css"

import exportComponent from "/tmp/build_642e477e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dedde06"]])

export default __exports__